import React, { useCallback }                       from "react";
import { useSelector }                              from "react-redux";
import { tripAttr }                                 from "../../../../../shared/config/constants";
import { 
  hrPackageTimeSelector, 
  multicityStopOversSelector, 
  showRTRevampSelector, 
  tripTypeSelector 
}                                                   from "../../../../../shared/common/redux/selector"
import Header2                                      from '../../../../core-components/Header2/Header2UI';
import * as S                                       from "./ReviewHeader.styles";

interface IReviewHeader {
  source_city       : string
  destination_city  : string
  tripType          : string
  dateString        : string
  source            : string
  destination       : string,
  endDateString     : string
}

const ReviewHeaderUI: React.FC<IReviewHeader> = ({
  source_city,
  destination_city,
  tripType,
  dateString,
  endDateString,
  source = "",
  destination = ""
}) => {
  const src             = source_city ? source_city : source;
  const desc            = destination_city ? destination_city : destination;
  const tripTypeDetails = useSelector(tripTypeSelector)
  const hrPackageTime   = useSelector(hrPackageTimeSelector)
  const stopOvers       = useSelector(multicityStopOversSelector)
  const isRTRevamp      = useSelector(showRTRevampSelector)

  const showSelectedPackageTime = useCallback(
    () => {
      return hrPackageTime ? hrPackageTime.toString().includes('hr') ? hrPackageTime : `${hrPackageTime} hr` : ''
    },[hrPackageTimeSelector]
  );

  const stopOversStr = useCallback(
    () => {
      return stopOvers?.map((stop) => {
        const str = stop?.value?.city_name
        return str.charAt(0).toUpperCase() + str.slice(1)
      }).join(' - ')
    }, [stopOvers]
  )

  return (
    <S.HeaderCont>
			<S.HeaderContInner>
				<Header2 textColor="#fff" margin={"0 0 2rem 0"} name={'Review your Booking'} />
        <div className="subHeading">
          <div className="subHeading__left">
            {tripTypeDetails?.rf === 'hr' ? (
              <>
                {src ? <span className="hrSubText fontSemiBold">{`${src}`}</span> : null}
              </>
            ) : (
              <>
                {stopOvers?.length ? (
                  <>
                    {src && desc ? tripTypeDetails?.rf === 'rt' ? <div className="stops-details fontSemiBold">{`${src} - ${stopOversStr()} - ${desc} - ${src}`}</div> : <div className="stops-details fontSemiBold">{`${src} - ${stopOversStr()} - ${desc}`}</div> : null}
                  </>
                ) : (
                  <>
                    {src && desc ? <div className="stops-details fontSemiBold">{`${src} - ${desc}`}</div> : null}
                  </>
                )}
              </>
            )}
            <p className="booking-details">
              {tripTypeDetails?.rf === 'hr' ? (
                <>
                  {tripAttr[tripTypeDetails?.name]?.name ? <span className="subText">{tripAttr[tripTypeDetails?.name]?.name} {showSelectedPackageTime().length ? `- ${showSelectedPackageTime()}` : ''}</span> : null}
                </>
              ) : (
                <>
                  {stopOversStr()?.length && dateString ? (tripTypeDetails?.rf === 'rt' ? <span className="subText">Multicity Roundtrip</span> : <span className="subText">Multicity Oneway</span>) : tripType ? <span className="subText">{tripType}</span> : null}
                </>
              )}
              {dateString ? <span className="fontSemiBold">Pick up : {dateString}</span> : null}
              {endDateString && (tripTypeDetails?.rf === 'rt' || stopOvers?.length) ? <span className="fontSemiBold endDate">Drop : {isRTRevamp && tripTypeDetails?.rf === 'rt' ? endDateString?.split(' - ')?.[0] : endDateString}</span> : null}
            </p>
          </div>
          <div className="subHeading__right">
            <span className="infoText">{'Hurry! Limited cars left'}</span>
          </div>
        </div>
      </S.HeaderContInner>
    </S.HeaderCont>
  );
};

export default ReviewHeaderUI;
